export default "__VITE_PUBLIC_ASSET__f95c2233__"